import Paper from "@material-ui/core/es/Paper/Paper";
import React from "react";
import ActionBar from "../components/ActionBar";
import FormView from "../components/FormView";
import Loader from "../components/Loader";
import * as API from "../util/api";
import * as Util from "../util/util";
import VLComponent from "./VLComponent";

class EditInputsScreen extends VLComponent {
  constructor() {
    super();
    this.state = { loaded: false, groups: [], sensor_name: "", ip_data: [], isV5: false };
  }

  componentDidMount() {
    Util.getLocation(pos => {
      this.setState({ lat: pos.coords.latitude, lng: pos.coords.longitude });
    });

    API.POST("systems/list", { sensor_id: this.props.id }, result => {
      Util.handleLogout(result);
      if (!result.success) return;

      const sensor = (result.result.sensors || [])[0];
      if (!sensor) return;

      const isV5 = !!sensor.idv5_camera;

      // V5 does not use this screen
      if (isV5) {
        this.basicAlert("Digital inputs are not available on V5 systems.", Util.goBack);
        return;
      }

      this.setState({ ...sensor, isV5: false });
      this.setState({ groups: result.result.groups });

      if (sensor.outstation_type === 3) {
        this.setState({ hiRes: true });
      }

      this.setState({ loaded: true });
    });
  }

  render() {
    return (
      <div>
        <ActionBar title={"Edit System - " + (this.state.sensor_name || "")} />
        {this.renderTextAlert()}
        <div
          id="content"
          style={{
            display: this.state.loaded ? "flex" : "none",
            padding: 24,
            justifyContent: "center"
          }}
        >
          <Paper
            style={{
              borderRadius: 16,
              width: "20cm",
              maxWidth: "90vw",
              maxHeight: "calc(100vh - 116px)",
              overflow: "hidden"
            }}
          >
            <div style={{ overflowY: "auto", height: "100%", padding: 16 }}>
              <FormView items={this.getItems()} changed={this.formChange} />
            </div>
          </Paper>
        </div>
        <Loader loaded={this.state.loaded} />
      </div>
    );
  }

  formChange = (name, val) => {
    let key = name.substring(4);
    let num = name.substring(2, 3);
    let ips = this.state.ip_data;
    ips[num - 1][key] = val;
    this.setState({ ip_data: ips });
  };

  save = () => {
    let data = { sensor_id: this.state.sensor_id };
    for (let i = 1; i <= 4; i++) {
      data["ip" + i + "_en"] = this.state.ip_data[i - 1].en;
      data["ip" + i + "_text"] = this.state.ip_data[i - 1].text;
      data["ip" + i + "_text_open"] = this.state.ip_data[i - 1].text_open;
      data["ip" + i + "_text_closed"] = this.state.ip_data[i - 1].text_closed;
      data["ip" + i + "_auto_message"] = this.state.ip_data[i - 1].auto_message;
    }
    API.POST("systems/setInputs", data, result => {
      if (result.success) {
        this.basicAlert("Your changes have been saved", () => {
          window.history.back();
        });
      } else {
        console.log(result.error);
        this.basicAlert(result.error);
      }
    });
  };

  getItems = () => {
    let space = [{ type: "spacer" }];
    let save = [{ type: "button", text: "Save", onClick: this.save }];
    let r = [{ type: "title", text: "Sensor Inputs" }];
    let ips = (this.state.ip_data || []).map((ip, index) => {
      let id = index + 1;
      return [
        { type: "title", text: "Input " + id },
        { id: "ip" + id + "_en", name: "Enabled", value: ip.en, type: "bool" },
        { id: "ip" + id + "_text", name: "Text", value: ip.text, type: "text" },
        { id: "ip" + id + "_text_open", name: "Open Text", value: ip.text_open, type: "text" },
        { id: "ip" + id + "_text_closed", name: "Closed Text", value: ip.text_closed, type: "text" },
        { id: "ip" + id + "_auto_message", name: "Auto Message", value: !!ip.auto_message, type: "bool" }
      ];
    });

    ips.forEach(ip => {
      r = r.concat(ip).concat(space);
    });

    return r.concat(save);
  };
}

export default EditInputsScreen;
